/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  calculateEarning,
  checkTransactionLimit,
  ClientInfo,
  Dispatch,
  formatPrice,
  GetProdBudSumData,
  getImageUrl,
  getRewardBaseDenomination,
  handleLimit,
  LoginV3Data,
  MaxQuan,
  showMaxMessg,
  SupplierCapping,
  trackEvent,
  TransactionLimit,
  useEarnRoiCalculationContext,
  useGaTrackingConfig,
} from "../Utility/Utility";
import defaultImage from "../../Assets/fallbackimg_giftcard.png";
import { onShowFailureReset } from "../../Store/Slices/cardDataSlice";
import { useRef } from "react";
import RewardWidget from "../RewardWidget/RewardWidget";
import { encryptURLParam } from "../../Common/Axios/encrypt";
import { onGetCustomerProduct } from "../../Store/Slices/customerProductSummarySlice";
import PurchaseLimitAlertTile from "../PurchaseLimitAlertTile/PurchaseLimitAlertTile";
import soldout from "../../Assets/soldout.png";
import deployedCodeAlert from "../../Assets/deployed_code_alert.png";
import PdpTermsActions from "./PdpTermsActions";
import pointIcon from "../../Assets/point_icon.svg";
import { onPostAddToCart, onPostAddToCartReset } from "../../Store/Slices/addToCartSlice";
const inFlightCustomerProductKeys = new Set();
const trackedViewItemIds = new Set();
const isEnabledConfigValue = (value) =>
  value === true ||
  value === 1 ||
  ["1", "true", "active"].includes(String(value ?? "").trim().toLowerCase());
const getDenominationSizeClass = (value) => {
  const digitCount = String(Math.trunc(Math.abs(Number(value) || 0))).length;

  if (digitCount >= 10) return "rs-price--xsmall";
  if (digitCount >= 8) return "rs-price--small";
  if (digitCount >= 6) return "rs-price--compact";
  return "";
};

const RedemptionDetails = ({ productReducer, isMobile }) => {
  const dispatch = Dispatch();
  const maxQuan = MaxQuan();
  const transactionLimit = TransactionLimit();
  const supplierCapping = SupplierCapping();
  const translation = getTranslationData();
  const navigate = useNavigate();
  const [finalAmount, setFinalAmount] = useState(0);
  const [arrayData, setArrayData] = useState([]);
  const [convenienceFee, setConvenienceFee] = useState(0);
  const [gst, setGst] = useState(0);
  const isLogin = sessionStorage.getItem("login");
  const location = useLocation();
  const { moduleData } = location.state || {};
  const [eventData, setEventData] = useState([]);
  //const [selectedCard, setSelectedCard] = useState({});
  const loginV3Data = LoginV3Data();
  const prodSumData = GetProdBudSumData();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [stockOutDenominations, setStockOutDenominations] = useState();
  const [outOfStockLabel, setOutOfStockLabel] = useState([]);
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const clientInfo = useSelector((state) => state.clientDataReducer);
  const clientConfigurationData = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData?.[0]
  );
  const gaTrackingConfig = useGaTrackingConfig();
  const rewardWidgetConfig = clientInfo?.clientData?.clientConfigurations?.find((config) => config.configKey === "isrewardwidgete");
  const AddToCartResponse = useSelector((state) => state.addToCartReducer);
  const minEarn = productReducer?.productReducer?.minEarnPoints || 0;
  const minBurn = productReducer?.productReducer?.maxEarnPoints || 0;
  let priceDenominations = [];
  const denominationList =
    productReducer?.productReducer?.clientProductDenomination;
  // Memoized so the [priceData] effect below runs only when denominations change,
  // instead of re-setting stock-out state (and re-rendering) after every render.
  const priceData = useMemo(
    () =>
      Array.isArray(denominationList)
        ? [...denominationList].sort(
          (a, b) => a?.denomination - b?.denomination
        )
        : [],
    [denominationList]
  );
  const enabledPriceData = useMemo(
    () =>
      Array.isArray(priceData)
        ? priceData.filter((item) => item?.enabled === true)
        : [],
    [priceData]
  );
  const rewardBaseDenomination = getRewardBaseDenomination({
    product: productReducer?.productReducer,
    // Reward rates are configured against the product's true minimum
    // denomination, even when that denomination is disabled for purchase.
    eligibleDenominations: priceData,
    fallbackDenominations: priceData,
  });
  const [earnPointsPerDenomination, setEarnPointsPerDenomination] = useState(
    priceDenominations.map(() => 0)
  );
  useEffect(() => {
    if (Array.isArray(priceData)) {
      priceDenominations = enabledPriceData.map((item) => item?.denomination);
      setStockOutDenominations(enabledPriceData.length > 0 && enabledPriceData.every((item) => item?.stockOut === true));
      setOutOfStockLabel(enabledPriceData.map(item => { return item?.stockOut }));

    }
  }, [priceData]);

  if (Array.isArray(priceData)) {
    priceDenominations = enabledPriceData.map(item => item?.denomination);

  }
  else {
    priceDenominations = [];
  }
  const discount =
    Number(productReducer?.productReducer?.customerDiscount) || 0;
  const V3Data = useSelector((state) => state.cardDataSliceReducer);

  // Initialize quantities to 0 for all price denominations
  const initialQuantities = priceDenominations.map(() => 0);
  const [quantities, setQuantities] = useState(initialQuantities);

  const totalDenominationAmount = priceDenominations?.reduce(
    (acc, price, index) => acc + Number(price || 0) * Number(quantities[index] || 0),
    0
  );
  const totalDenominationAfterDiscountAmount =
    totalDenominationAmount - (totalDenominationAmount * Number(discount || 0)) / 100;
  const convenienceFeeAmount =
    (totalDenominationAfterDiscountAmount * Number(convenienceFee || 0)) / 100;
  const gstAmount = (convenienceFeeAmount * Number(gst || 0)) / 100;
  const payableAmount = totalDenominationAfterDiscountAmount + convenienceFeeAmount + gstAmount;

  const { isTransactionLimitExceeded } = checkTransactionLimit({
    transactionAmountType: transactionLimit?.transactionAmountType,
    totalAmountCapping: transactionLimit?.totalAmountCapping,
    totalDenominationAmount,
    totalDenominationAfterDiscountAmount,
    payableAmount,
  });

  useEffect(() => {
    if (moduleData) {
      const newQuantities = priceDenominations.map((price) => {
        const match = moduleData.find((item) => item.denomination === price);
        return match ? match.quantity : 0;
      });
      setQuantities(newQuantities);
    } else {
      setQuantities(initialQuantities);
    }
  }, [productReducer, moduleData]);

  useEffect(() => {
    if (productReducer && typeof productReducer === "object") {
      const fee = Number(productReducer.productReducer.convenienceFee);
      const tax = Number(productReducer.productReducer.gst);

      setConvenienceFee(isNaN(fee) ? 0 : fee);
      setGst(isNaN(tax) ? 0 : tax);
    } else {
      setConvenienceFee();
      setGst(0);
    }
  }, [productReducer]);
  useEffect(() => {
    handleLimit(
      finalAmount,
      prodSumData?.getCustomerProduct,
      dispatch,
      translation,
      productReducer?.productReducer?.productBudget?.limits
    );
  }, [finalAmount]);
  const handleIncrease = (index, value) => {
    setQuantities((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      const nextValue = newQuantities[index] + 1;
      newQuantities[index] = nextValue;

      const projectedTotalDenominationAmount = priceDenominations?.reduce(
        (acc, price, idx) => acc + Number(price || 0) * Number(newQuantities[idx] || 0),
        0
      );
      const projectedTotalAfterDiscountAmount =
        projectedTotalDenominationAmount -
        (projectedTotalDenominationAmount * Number(discount || 0)) / 100;
      const projectedConvenienceFeeAmount =
        (projectedTotalAfterDiscountAmount * Number(convenienceFee || 0)) / 100;
      const projectedGstAmount =
        (projectedConvenienceFeeAmount * Number(gst || 0)) / 100;
      const projectedPayableAmount =
        projectedTotalAfterDiscountAmount +
        projectedConvenienceFeeAmount +
        projectedGstAmount;

      const { isTransactionLimitExceeded: isProjectedTransactionLimitExceeded } =
        checkTransactionLimit({
          transactionAmountType: transactionLimit?.transactionAmountType,
          totalAmountCapping: transactionLimit?.totalAmountCapping,
          totalDenominationAmount: projectedTotalDenominationAmount,
          totalDenominationAfterDiscountAmount: projectedTotalAfterDiscountAmount,
          payableAmount: projectedPayableAmount,
        });

      if (isProjectedTransactionLimitExceeded) {
        toast.error(translation?.transaction_limit_exceed);
        return prevQuantities;
      } else if (supplierCapping > 0 && nextValue === supplierCapping) {
        showMaxMessg(
          translation.max_capping_allowed,
          supplierCapping,
          1,
          value
        );
      }
      const selectedCard = localStorage.getItem("RewardWidget");
      const cardData = cardListData?.clientConfigData?.cards?.find(
        (card) => card.cardId === selectedCard
      );
      let rewardPoints = 0;
      if (cardData) {
        rewardPoints = Math.round(
          (projectedPayableAmount / cardData.perRs) *
          cardData.standardPoints *
          (cardData.bonusPoints / cardData.standardPoints + 1)
        );
      }
      setEarnPointsPerDenomination((prev) => {
        const updatedEarnPoints = [...prev];
        updatedEarnPoints[index] = calculateEarnPoints(value);

        // Build eventData preserving original indices so denominations map correctly
        const combined = newQuantities
          .map((qty, i) => {
            if (!qty || qty <= 0) return null;
            return {
              index: parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) || null,
              quantity: qty,
              gift_card_points: priceDenominations[i],
              price:
                priceDenominations[i] -
                (priceDenominations[i] * discount) / 100,
              item_id: productReducer?.productReducer?.sku || "",
              item_brand: productReducer?.productReducer?.name || "",
              item_name: productReducer?.productReducer?.name || "",
              // affiliation: gaTrackingConfig.trackingContext.affiliation,
              item_category: "Giftcards",
              item_category2: productReducer?.productReducer?.clientCategoryName || "",
              item_image: getImageUrl(productReducer?.productReducer?.small) || defaultImage,
              item_url: productReducer?.productReducer?.url || window.location.href,
              item_list_name: sessionStorage.getItem("ga4_item_list_name") || "",
              item_list_id: sessionStorage.getItem("ga4_item_list_name") || "",
              //  discount: ((productReducer?.denomination || 0) * discountPercent) / 100 * qty,
            };
          })
          .filter(Boolean);
        setEventData(combined);
        return updatedEarnPoints;
      });

      return newQuantities;
    });
  };

  const handleDecrease = (index, value) => {
    setQuantities((prevQuantities) => {
      const newQuantities = [...prevQuantities];

      if (newQuantities[index] > 0) {
        newQuantities[index] -= 1;
      }

      setEarnPointsPerDenomination((prev) => {
        const updatedEarnPoints = [...prev];
        updatedEarnPoints[index] =
          newQuantities[index] > 0
            ? calculateEarnPoints(priceDenominations[index])
            : 0;
        return updatedEarnPoints;
      });
      const combined = newQuantities
        .map((qty, i) => {
          if (!qty || qty <= 0) return null;
          return {
            quantity: qty,
            earnPoint: calculateEarnPoints(priceDenominations[i]),
            priceDenomination: priceDenominations[i],
          };
        })
        .filter(Boolean);

      setEventData(combined);

      return newQuantities;
    });
  };
  useEffect(() => {
    const newFinalAmount = priceDenominations.reduce((acc, price, index) => {
      return acc + price * quantities[index];
    }, 0);

    const newArrayData = priceDenominations
      .map((item, index) => {
        const qty = quantities[index] || 0;
        if (qty > 0) {
          return {
            denomination: item,
            you_pay: (item - (item * discount) / 100).toFixed(2),
            saving: ((item * discount) / 100).toFixed(2),
            quantity: quantities[index],
          };
        }
        return null; // mark invalid ones
      })
      .filter((obj) => obj !== null);

    setArrayData(newArrayData);
    setFinalAmount(newFinalAmount);
  }, [quantities, discount, convenienceFee, gst]);

  const totalGiftcard = quantities.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  // build payload for add to cart api
  const buildAddToCartPayload = () => ({
    memberId: loginV3Data?.memberIdentifier || "",
    items: [
      {
        productId: Number(productReducer?.productReducer?.id || 0),
        sku: productReducer?.productReducer?.sku || "",
        name: productReducer?.productReducer?.name || "",
        supplierCode: "asdfg",
        productImage:
          getImageUrl(productReducer?.productReducer?.small) || defaultImage,
        createdAt:
          productReducer?.productReducer?.createdAt ||
          new Date().toISOString(),
        updatedAt:
          productReducer?.productReducer?.updatedAt ||
          new Date().toISOString(),
        productDetails: arrayData.map((item) => ({
          denomination: Number(item?.denomination || 0),
          qty: Number(item?.quantity || 0),
          addedAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        })),
      },
    ],
  });

  useEffect(() => {
    if (AddToCartResponse?.post_status_code === "200") {
      const productIdValue =
        productReducer?.productReducer?.id?.toString();

      const finalProductId =
        process.env.REACT_APP_IS_E_E === "false"
          ? productIdValue
          : encryptURLParam(productIdValue);

      // Pending request has completed successfully
      sessionStorage.removeItem("pendingAddToCartPayload");
      sessionStorage.removeItem("pendingAddToCartReturnPath");
      dispatch(onPostAddToCartReset());
      navigate(`/card?productId=${finalProductId}`, {
        state: { arrayData },
      });
    }
    else if (["400", "401", "500"].includes(AddToCartResponse?.post_status_code)) {
      toast.error(
        AddToCartResponse?.postMessage || "Unable to add product to cart"
      );
      dispatch(onPostAddToCartReset());
    }
  }, [AddToCartResponse?.post_status_code]);

  const handleClick = () => {
    if (isTransactionLimitExceeded) {
      toast.error(translation?.transaction_limit_exceed);
      return;
    }

    const finalValue =
      finalAmount -
      (finalAmount * discount) / 100 +
      ((finalAmount - (finalAmount * discount) / 100) * convenienceFee) / 100 +
      (((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
        100) *
      (gst / 100);

    const finalDiscount = (finalAmount * discount) / 100;
    const selectedCard = localStorage.getItem("RewardWidget");

    if (maxQuan > 0 && totalGiftcard > maxQuan) {
      showMaxMessg(translation.max_limit_allowed, maxQuan);
      return;
    }

    if (totalGiftcard <= 0) {
      toast.error("Please add the product");
      return;
    }

    // Existing GA tracking - keep unchanged
    trackEvent("add_to_cart", {
      page_type: "product_page",
      client_code: gaTrackingConfig.trackingContext.client_code,
      platform_code: gaTrackingConfig.trackingContext.platform_code,

      total_gift_card_points: priceDenominations.reduce(
        (sum, denomination, index) => {
          return sum + denomination * quantities[index];
        },
        0
      ),

      card_name: selectedCard ? selectedCard : "NA",

      ecommerce: {
        currency: "INR",
        value: finalValue,
        discount: finalDiscount,
        items: eventData || [],
      },
    });

    // Build the SAME payload that Add To Cart API expects
    const payload = buildAddToCartPayload();

    if (!isLogin) {
      const productIdValue =
        productReducer?.productReducer?.id?.toString();

      const finalProductId =
        process.env.REACT_APP_IS_E_E === "false"
          ? productIdValue
          : encryptURLParam(productIdValue);

      const pathName = window.location.pathname;
      const search = window.location.search;

      // Existing redirect information
      localStorage.setItem(
        "ProductListPage",
        `/card?productId=${finalProductId}`
      );

      localStorage.setItem(
        "ProductListPage_back",
        pathName + search
      );

      sessionStorage.setItem(
        "arrayData",
        JSON.stringify(arrayData)
      );

      // IMPORTANT: save complete Add To Cart request
      sessionStorage.setItem(
        "pendingAddToCartPayload",
        JSON.stringify(payload)
      );

      // After login, failure case should come back here
      sessionStorage.setItem(
        "pendingAddToCartReturnPath",
        pathName + search
      );

      // Go to login
      window.location.href = V3Data?.SignInUrl;

      return;
    }
    // Logged-in user
    dispatch(onPostAddToCart(payload));
  };

  useEffect(() => {
    if (location.state?.addToCartError) {
      toast.error(location.state.addToCartError);
    }
  }, []);
  const calculateEarnData = (amount) => {
    const amountAfterDiscount =
      Number(amount || 0) -
      (Number(amount || 0) * Number(discount || 0)) / 100;

    return calculateEarning({
      ...earnRoiCalculationContext,
      amount: amountAfterDiscount,
      minEarnPoints: minEarn,
      minBurnPoints: minBurn,
      baseDenomination: rewardBaseDenomination,
    });
  };

  const calculateEarnPoints = (amount) => calculateEarnData(amount).points;

  useEffect(() => {
    if (!gaTrackingConfig?.trackingContext) return;

    const productTrackingId =
      productReducer?.productReducer?.sku ||
      productReducer?.productReducer?.id ||
      window.location.href;

    if (!productTrackingId) return;

    const viewItemTrackingKey = `${location?.key || "no-key"}:${productTrackingId}`;
    if (trackedViewItemIds.has(viewItemTrackingKey)) return;
    trackedViewItemIds.add(viewItemTrackingKey);

    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard,
    );
    trackEvent("view_item", {
      page_url: window.location.href,
      page_type: "product_page",
      ...gaTrackingConfig.trackingContext,
      DefaultCard: cardData?.cardName || "NA",

      ecommerce: {
        items: [
          {
            index: parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) || null,
            item_name: productReducer?.productReducer?.name,
            item_id: productReducer?.productReducer?.sku,
            item_category: "Giftcards",
            item_category2: productReducer?.productReducer?.clientCategoryName || "",
            item_brand: productReducer?.productReducer?.name,
            //  affiliation: gaTrackingConfig.trackingContext.affiliation,
            item_image: getImageUrl(productReducer?.productReducer?.small) || defaultImage,
            item_url: productReducer?.productReducer?.url || window.location.href,
            // offer_type: productReducer?.productReducer?.type || "",
            item_list_name: sessionStorage.getItem("ga4_item_list_name") || "",
            item_list_id: sessionStorage.getItem("ga4_item_list_name") || "",
          },

        ],
      }
    });
  }, [
    location?.key,
    productReducer?.productReducer?.sku,
    productReducer?.productReducer?.id,
    gaTrackingConfig?.trackingContext,
    cardListData?.clientConfigData?.cards,
  ]);
  const clientinfo = ClientInfo();
  const earnRoiCalculationContext = useEarnRoiCalculationContext();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview"
  )?.configValue;
  const isEarn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearn"
  )?.configValue;
  const earnLabelConfig =
    clientConfigurationData?.clientConfig?.find(
      (item) =>
        String(item?.configKey ?? "").trim().toLowerCase() ===
        "isearnlabelshowonly"
    )?.configValue ??
    clientConfigurationData?.isEarnLabelShowOnly ??
    clientConfigurations?.find(
      (item) =>
        String(item?.configKey ?? "").trim().toLowerCase() ===
        "isearnlabelshowonly"
    )?.configValue;
  const isEarnLabelShowOnly = isEnabledConfigValue(earnLabelConfig);
  const journeyType = clientinfo?.clientData?.journeyType;
  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const useEarnLabelOnly = isEarnLabelShowOnly && !isWalletJourney;
  const hasEarnConfiguration =
    Number(minEarn) > 0 && isEarn !== "2" && isEarnView !== "2";
  const showEarnLabelOnly = useEarnLabelOnly && hasEarnConfiguration;
  const totalEarning = calculateEarning({
    ...earnRoiCalculationContext,
    amount: payableAmount,
    minEarnPoints: minEarn,
    minBurnPoints: minBurn,
    baseDenomination: rewardBaseDenomination,
  });
  const showEarnMessage =
    showEarnLabelOnly && totalEarning.points > 0;
  useEffect(() => {
    document.body.classList.add("redemption-details-active");
    return () => {
      document.body.classList.remove("redemption-details-active");
    };
  }, []);

  const memberId = `${loginV3Data?.memberIdentifier ?? ""}`;
  const productId = `${productReducer?.productReducer?.id ?? ""}`;
  const hasFetched = useRef(false);

  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("login") === "true";
    const loginSessionToken = sessionStorage.getItem("loginSessionToken");

    if (!isLoggedIn || !loginSessionToken || !memberId || !productId) return;

    const key = `${memberId}:${productId}`;
    if (hasFetched.current || inFlightCustomerProductKeys.has(key)) return;

    hasFetched.current = true;
    inFlightCustomerProductKeys.add(key);
    dispatch(
      onGetCustomerProduct({
        customerId: memberId,
        productIdentifier: productId,
      })
    );

    return () => {
      const RELEASE_DELAY_MS = 3000;
      setTimeout(
        () => inFlightCustomerProductKeys.delete(key),
        RELEASE_DELAY_MS
      );
    };
  }, [memberId, productId]);
  return (
    <div className="redemption-details-page">
      <ToastContainer />
      {stockOutDenominations ? (
        <div className="row">

          <div className="col-lg-4"></div>
          <div className="col-lg-8 col-12">
            <div className="mod-head redeem-padd mt-0">
              <h5 className="heading1 mb-0">

                {translation.AvailabilityOfDenominations}

              </h5>
            </div>
            <div className="redemption_soldOutBox text-center mt-2 mb-4">

              <div className="stockout-image ">
                <img src={soldout} alt="Sold Out" className="mb-1 stockoutdefault" />
                <img src={deployedCodeAlert} alt="Sold Out" className="mb-1 stockoutImage" />
                <p className="stockout-text ">
                  {translation?.stock_out}
                </p>
                <p>{translation?.stockout_message_desc_all_denomination}

                </p>
              </div>
            </div>
            <div className="mobile-sticky-footer">
              <div className="mt-3 redem-buy-sp text-center mb-2 giftBuyBtn">
                <a
                  className="continue-wh buy-detailpro buy-stockupDetailpro"
                  // onClick={V3Data?.disable ? undefined : handleClick}
                  style={{
                    cursor: "not-allowed",
                    backgroundColor: "var(--disable-continue-color)"
                  }}
                >
                  <span className="pdp-cta-label-default">
                    {translation?.continue}
                  </span>
                  <span className="d-none pdp-cta-label-cc">
                    {translation?.luxury_confirm_text}
                  </span>
                </a>
              </div>
              <div className="redeem-padd info-box text-center redeem-pt">
                {/* <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span> */}
                {translation?.pay_with_membership_rewards_at_safekey_checkout}
              </div>
            </div>
          </div>

        </div>
      ) : (
        <div className="row justify-content-center">
          <div className={`col-12 ${!isMobile && !rewardWidgetConfig ? "col-lg-6" : "col-lg-12"}`}>
            <div key={productReducer?.productReducer?.productId} className="row">
              {(!isMobile && rewardWidgetConfig?.configValue === "1") && <div className="col-lg-6 col-12 pdp-reward-widget-column">
                <RewardWidget
                  totalAmount={
                    finalAmount -
                    (finalAmount * discount) / 100 +
                    ((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                    100 +
                    (((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                      100) *
                    (gst / 100)
                  }
                  className={V3Data?.disable ? "mt-3" : ""}
                />

              </div>
              }
              <div className={`${rewardWidgetConfig?.configValue === "1" ? "col-lg-6" : "col-lg-12"} col-12 pdp-denomination-list-column`}>
                <div className="mod-head redeem-padd mt-0">
                  <h5 className="heading1 mb-0">
                    {maxQuan !== 0 && translation?.chooseYourDenomination && (
                      <>
                        <span className="pdp-denomination-heading-default">
                          {translation.chooseYourDenomination} (up to {maxQuan})
                        </span>
                        <span className="d-none pdp-denomination-heading-cc">
                          {translation?.luxuryChooseYourDenomination?.replace(
                            "{maxQuan}",
                            maxQuan,
                          )}
                        </span>
                      </>
                    )}
                  </h5>
                </div>
                {priceDenominations.map((item, index) => (
                  <div className="row p-2 align-card" key={index}>
                    <div className="first-new col-lg-6 col-9">
                      <div className={`d-flex justify-content-start mb-3 ${outOfStockLabel?.[index] ? "out-of-stock" : ""}`}>
                        <div className="mrg-lft">
                          <div
                            className="amount-box"
                          // className="background_image"
                          // style={{ backgroundImage: url(${bgImage}) }}
                          >
                            <div className={`price_in_box rs_price ${getDenominationSizeClass(item)}`}>
                              <span className="currency">₹</span>
                              <span className="amount">{item}</span>
                            </div>
                            {/* <img
                      alt="not-found"
                      src={boxLine}
                      className="point-box-line"
                    /> */}
                          </div>
                        </div>
                        <>
                          {!showEarnLabelOnly && (
                            <div className="font-blk padd-lft demonination_price_box">
                              <span className="mrp_price_box">
                                {productReducer?.productReducer?.customerDiscount !== 0 &&
                                  item !== item - (item * discount) / 100 ? (
                                  <>
                                    <strike
                                      className="pro-mrp"
                                      style={{ textDecoration: "line-through" }}
                                    >
                                      ₹{item?.toLocaleString()}
                                    </strike>
                                    <span className="pdp-price-spacer">&nbsp;&nbsp;</span>
                                  </>
                                ) : (
                                  <span className="mrl"></span>
                                )}
                                <span className="actual-mrp">
                                  ₹
                                  {(() => {
                                    const value = item - (item * discount) / 100;
                                    const isWhole = value % 1 === 0;
                                    return value.toLocaleString(undefined, {
                                      minimumFractionDigits: isWhole ? 0 : 2,
                                      maximumFractionDigits: 2,
                                    });
                                  })()}
                                </span>
                              </span>
                              {hasEarnConfiguration && (() => {
                                const denominationEarning = calculateEarnData(item);
                                if (denominationEarning.points <= 0) return null;

                                return (
                                  <div className="fa_star_border1 mt-2">
                                    <span className="fa_star_box">
                                      {translation?.earn}&nbsp;
                                      {denominationEarning.points.toLocaleString("en-IN")} {translation?.pts}
                                    </span>
                                  </div>
                                );
                              })()}
                            </div>
                          )}
                          {showEarnLabelOnly && (() => {
                            const denominationEarning = calculateEarnData(item);
                            if (denominationEarning.points <= 0) return null;

                            return (
                              <div className="pdp-denomination-reward-box">
                                <div className="pdp-denomination-earn">
                                  <span className="pdp-denomination-earn-content">
                                    <span className="pdp-denomination-earn-line">
                                      {translation?.earn}{" "}
                                      <img src={pointIcon} alt="" aria-hidden="true" />{" "}
                                      <b className="pdp-earned-points">{denominationEarning.points.toLocaleString("en-IN")}</b>
                                    </span>
                                    {denominationEarning.worth > 0 && (
                                      <span className="pdp-denomination-worth">
                                        {translation?.worth || "worth ₹"}{formatPrice(denominationEarning.worth)}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </div>
                            );
                          })()}
                        </>
                      </div>
                    </div>
                    <div
                      className="second-new col-lg-6 col-3 p-0 pl-2"
                    >

                      {outOfStockLabel?.[index] ? (
                        <div className="stockOutContent stockOutPdp">
                          <div className="stockOut">
                            {translation?.out_of_stock}
                          </div>
                        </div>
                      ) :
                        (<div className="input forMob_rights">
                          {quantities[index] > 0 && (
                            <button
                              className="minus minus1"
                              aria-label="Decrease by one"
                              onClick={() => handleDecrease(index, item)}
                            >
                              <svg
                                width="16"
                                height="2"
                                viewBox="0 0 16 2"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <line
                                  y1="1"
                                  x2="14"
                                  y2="1"
                                  stroke="var(--plus-minus-color)"
                                  strokeWidth="2"
                                  className="icon"
                                ></line>
                              </svg>
                            </button>
                          )}
                          {quantities[index] > 0 && (
                            <div className="number dim mb-3 gift_qty_box">
                              {quantities[index]}
                            </div>
                          )}
                          <button
                            className={`plus plus1 ${supplierCapping > 0 && quantities[index] === supplierCapping
                              ? "quantity-disabled"
                              : ""
                              }`}
                            aria-label="Increase by one"
                            onClick={() => handleIncrease(index, item)}
                            disabled={
                              (supplierCapping > 0 &&
                                quantities[index] === supplierCapping) ||
                              V3Data?.disable || isTransactionLimitExceeded
                            }
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                            >
                              <line
                                x1="8"
                                y1="0"
                                x2="8"
                                y2="16"
                                stroke="var(--plus-minus-color)"
                                strokeWidth="2"
                              ></line>
                              <line
                                y1="8"
                                x2="16"
                                y2="8"
                                stroke="var(--plus-minus-color)"
                                strokeWidth="2"
                              ></line>
                            </svg>
                          </button>
                        </div>)}
                    </div>
                  </div>
                ))}
                {V3Data?.disable && (
                  <PurchaseLimitAlertTile
                    timePeriod={V3Data?.timePeriod}
                    amount={V3Data?.amount}
                    reset_text={V3Data?.reset_text}
                    name={productReducer?.productReducer?.name}
                  />
                )}

                {isMobile && <>
                  <RewardWidget
                    totalAmount={
                      finalAmount -
                      (finalAmount * discount) / 100 +
                      ((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                      100 +
                      (((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                        100) *
                      (gst / 100)
                    }
                    className={V3Data?.disable ? "mt-3" : ""}
                  /> </>}

                <span className="gift-card-bord"></span>
                <>
                  <div className={`pdp-order-summary${isWalletJourney ? " non-cc-pdp-order-summary-card" : ""}`}>
                    <div className="d-flex justify-content-between mt-4 redem-buy-sp redem-buy-now">
                      <div className="belowvalue">
                        <span className="lip pdp-summary-default-label">
                          {totalGiftcard} {translation?.giftCard}
                          {totalGiftcard > 1 ? "s" : ""}
                        </span>
                        <span className="lip d-none pdp-summary-label">
                          {translation?.totalGiftCardValue}
                        </span>
                        {!useEarnLabelOnly &&
                          !isWalletJourney &&
                          hasEarnConfiguration &&
                          totalEarning.points > 0 && (
                            <div className="fa_star_border finalPoints f-star-bg">
                              <span className="fa_star_box1">
                                {translation?.earn}&nbsp;
                                {totalEarning.points.toLocaleString("en-IN")} {translation?.pts}
                              </span>
                            </div>
                          )}
                      </div>
                      <div className="belowvalueright">
                        <span className="prorightp">₹{finalAmount.toLocaleString()}</span>
                      </div>
                    </div>

                    {discount > 0 && (
                      <div className="d-flex justify-content-between mt-2 redem-buy-now">
                        <div className="belowvalue">
                          <span className="lip">{translation?.discount}</span>
                        </div>
                        <div className="belowvalueright">
                          <span className="prorightp">
                            ₹
                            {(() => {
                              const discountAmount =
                                finalAmount -
                                (finalAmount - (finalAmount * discount) / 100);

                              return discountAmount % 1 === 0
                                ? discountAmount.toLocaleString()
                                : discountAmount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                });
                            })()}
                          </span>
                        </div>
                      </div>
                    )}

                    {totalGiftcard > 0 && (convenienceFee > 0 || gst > 0) && (
                      <div className="d-flex justify-content-between mt-2 redem-buy-now pdp-fee-row">
                        <div className="belowvalue">
                          {convenienceFee > 0 && (
                            <>
                              <span className="lip d-block">
                                {translation?.convenience_fe}
                              </span>
                              <span className="lip">({convenienceFee}%)</span>
                            </>
                          )}
                          {gst > 0 && <span className="lip">{translation?.plus_gst}</span>}
                        </div>
                        <div className="belowvalueright">
                          <span className="prorightp">
                            ₹
                            {(() => {
                              const amount =
                                ((finalAmount - (finalAmount * discount) / 100) *
                                  (convenienceFee || 0)) /
                                100 +
                                (((finalAmount - (finalAmount * discount) / 100) *
                                  (convenienceFee || 0)) /
                                  100) *
                                ((gst || 0) / 100);

                              return amount % 1 === 0
                                ? amount.toLocaleString()
                                : amount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                });
                            })()}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-between mt-2 redem-buy-now">
                      <div className="belowvalue topaylable">
                        <span className="lip_totalAmount pdp-summary-default-label">
                          {translation?.totalAmount}
                        </span>
                        <span className="lip_totalAmount d-none pdp-summary-label">
                          {translation?.toPay}
                        </span>
                      </div>
                      <div className="belowvalueright">
                        <span className="prorightp payamoutvale">
                          ₹{formatPrice(payableAmount)}
                        </span>
                      </div>
                    </div>
                    {isWalletJourney &&
                      hasEarnConfiguration &&
                      totalEarning.points > 0 && (
                        <div className="non-cc-pdp-earn-summary">
                          {isEarnLabelShowOnly ? (
                            <>
                              <span>{translation?.checkoutWillEarn}</span>{" "}
                              <b className="pdp-earned-points">{totalEarning.points.toLocaleString("en-IN")}</b>{" "}
                              {totalEarning.worth > 0 && (
                                <>{translation?.checkoutWorth} ₹{formatPrice(totalEarning.worth)}</>
                              )}
                            </>
                          ) : (
                            <>
                              <span>{translation?.earn}</span>{" "}
                              <b className="pdp-earned-points">{totalEarning.points.toLocaleString("en-IN")}</b>{" "}
                              <span>{translation?.pts}</span>
                            </>
                          )}
                        </div>
                      )}
                    {showEarnMessage && (
                      <div className="pdp-earn-summary">
                        <span>{translation?.checkoutWillEarn}</span>{" "}
                        <img src={pointIcon} alt="" aria-hidden="true" />{" "}
                        <b className="pdp-earned-points">{totalEarning.points.toLocaleString("en-IN")}</b>{" "}
                        {totalEarning.worth > 0 && (
                          <> {translation?.checkoutWorth} ₹{formatPrice(totalEarning.worth)}</>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="d-none pdp-checkout-note">
                    <span className="pdp-checkout-note-icon" aria-hidden="true">
                      i
                    </span>
                    <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span>
                    {translation?.redeemPointsCheckout}
                  </div>

                  <PdpTermsActions
                    productDetails={productReducer}
                    placement="below-amount"
                  />

                  <div className="mobile-sticky-footer">
                    <div className="mt-3 redem-buy-sp text-center mb-2 giftBuyBtn">
                      <a
                        className="continue-wh buy-detailpro buy-stockupDetailpro"
                        onClick={V3Data?.disable || isTransactionLimitExceeded ? undefined : handleClick}
                        style={{
                          cursor: V3Data?.disable || isTransactionLimitExceeded ? "not-allowed" : "pointer",
                          backgroundColor: V3Data?.disable || isTransactionLimitExceeded
                            ? "var(--disable-continue-color)"
                            : "var(--login-button-color)",
                        }}
                      >

                        {AddToCartResponse?.isPostLoading ? (
                          <span className="spinner-border spinner-border-sm"></span>) : (<>
                            <span className="pdp-cta-label-default">
                              {translation?.continue}
                            </span>
                            <span className="d-none pdp-cta-label-cc">
                              {translation?.luxury_confirm_text}
                            </span>
                          </>)}
                      </a>
                    </div>
                    <div className="redeem-padd info-box text-center redeem-pt">
                      <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span>
                      {translation?.redeemPointsCheckout}
                    </div>
                    <div className="d-none pdp-cta-footnote">
                      {translation?.pay_with_membership_rewards_at_safekey_checkout}
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RedemptionDetails;
